import Snake from './Snake';
import texts from './data.js';

export const SnakeCanvas = () => {
    return (
      <div style={ { width: '100%', height: '100%', cursor: 'none' } }>
  
        <Snake 
          strokeColor='blue'
          documentBackgroundColor='white'
          fillColor='silver'
          texts={texts[0]}
        />
        <Snake 
          strokeColor='red'
          texts={texts[1]}
          gap={ 0 }
          strokeWidth={ 75 }
        />
        <Snake 
          strokeColor='white'
          strokeWidth={ 200 }
          gap={ 5 }
          increment={ 100 }
          documentBackgroundColor='green'
          fillColor='lightgreen'
          texts={texts[2]}
        />
        <Snake
          strokeColor='white'
          strokeWidth={ 5 }
          gap={ 50 }
          increment={ 10 }
          documentBackgroundColor='blue'
          fillColor='orange'
          barColor='rgba(255,255,255,0.5)'
          texts={texts[3]}
        />
      </div>
    );
  };
  
  export default SnakeCanvas;